import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import MessageCard from "../AdminCards/MessageCard";
import { languageHelper } from "../../config/helperFunctions";

function CartDetails({
  handleOrder,
  setCouponCode,
  handleApplyCoupon,
  couponDiscount,
  couponError,
  validation,
}) {
  
  const location = useLocation();

  const isCheckout = location.pathname === "/checkout";

  const data = useSelector((state) => state.products.cart);

  let subTotal = 0;
  let totalVat = 0;
  let totalDiscount = 0;
  let totalExtraToppings = 0;
  let total = 0;

  data.forEach((item) => {
    subTotal +=
      (item.tax_method === "inclusive" ? item.price - item.vat : item.price) *
      item.quantity;
    // totalVat +=
    //   ((item.tax_method === "exclusive" ? item.vat : 0) + item.extra_vat) *
    //   item.quantity;
    totalVat += (item.vat + item.extra_vat) * item.quantity;
    totalDiscount += parseFloat(item.discount) * item.quantity || 0;
    item.modifiers.forEach((mod) => {
      totalExtraToppings += mod.modifier_price;
    });
  });

  total += subTotal + totalVat - totalDiscount + totalExtraToppings;

  return (
    <>
      <div className="flex flex-col w-full  rounded-xl p-5 mt-5 lg:m-5 border border-w-border">
        <p className="text-3xl font-bold text-w-heading">{languageHelper("payment summary") || "Payment Summary"}</p>
        <hr className="my-2 bg-transparent border-t border-w-border border-dashed" />
        <div className="flex font-medium justify-between">
          <div>
            <p>{languageHelper("sub total") || "Sub Total"}</p>
          </div>
          <div>
            <p>{subTotal.toFixed(2)} {languageHelper("sar") || "SAR"}</p>
          </div>
        </div>
        <br />
        <div className="flex font-medium justify-between">
          <div>
            <p>{languageHelper("discount") || "Discount"}</p>
          </div>
          <div>
            <p>{totalDiscount.toFixed(2)} {languageHelper("sar") || "SAR"}</p>
          </div>
        </div>
        <hr className="my-2 bg-transparent border-t border-w-border border-dashed" />
        <div className="flex font-medium justify-between">
          <div>
            <p>{languageHelper("extra topping") || "Extra Topping"}</p>
          </div>
          <div>
            <p>{totalExtraToppings.toFixed(2)} {languageHelper("sar") || "SAR"}</p>
          </div>
        </div>
        <hr className="my-2 bg-transparent border-t border-w-border border-dashed" />
        <div className="flex  font-medium justify-between">
          <div>
            <p>{languageHelper("vat") || "VAT"}</p>
          </div>
          <div>
            <p>{totalVat.toFixed(2)} {languageHelper("sar") || "SAR"}</p>
          </div>
        </div>
        <hr className="my-2 bg-transparent border-t-2 border-w-border border-dashed" />
        <div className="flex font-medium justify-between">
          <div>
            <p>{languageHelper("total amount")}</p>
          </div>
          <div>
            <p className={`${couponDiscount && "line-through"}`}>{total.toFixed(2)} {languageHelper("sar")}</p>
            <p>{couponDiscount && `${couponDiscount.toFixed(2)} ${languageHelper("sar")}`}</p>
          </div>
        </div>
        <hr className="my-2 bg-transparent border-t-2 border-w-border border-dashed" />
        {isCheckout && (
          <>
            <div className="flex gap-2 border border-w-border px-2 py-1 rounded-md">
              <input
                className="w-full px-2 py-1 focus:outline-none"
                placeholder="Coupon Code"
                type="text"
                onChange={(e) => setCouponCode(e.target.value)}
              />
              <button
                onClick={handleApplyCoupon}
                className="bg-w-btn text-w-btn-text px-2 py-1 rounded-md"
              >
                {languageHelper("apply") || "Apply"}
              </button>
            </div>
            {couponError && (
              <div className="mt-2">
                <MessageCard error={couponError} />
              </div>
            )}
            {validation && (
              <div className="mt-2">
                <MessageCard error={validation} />
              </div>
            )}
          </>
        )}
      </div>
      {!isCheckout && (
        <Link
          to="/checkout"
          className="flex justify-center flex-col w-full font-bold text-lg  rounded-lg p-2 mt-5 lg:m-5 border border-w-border bg-w-btn text-w-btn-text"
        >
          <div className="flex justify-center">
            <div>{languageHelper("continue to checkout") || "Continue To Checkout"}</div>
          </div>
        </Link>
      )}
      {isCheckout && (
        <button
          to="/thankyou"
          onClick={handleOrder}
          className="flex justify-center flex-col w-full font-bold text-lg  rounded-lg p-2 mt-5 lg:m-5 border border-w-border bg-w-btn text-w-btn-text"
        >
          <div className="flex justify-center">
            <div>{languageHelper("place order") || "Place Order"}</div>
          </div>
        </button>
      )}
    </>
  );
}

export default CartDetails;
